import { render, staticRenderFns } from "./MovimientosBancariosComponent.vue?vue&type=template&id=8cb80a84&"
import script from "./MovimientosBancariosComponent.vue?vue&type=script&lang=js&"
export * from "./MovimientosBancariosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports